var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 111,
    viewBox: "0 0 49 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.0792 83.5227C38.4391 91.4377 42.2341 97.0022 47.9265 105.349C49.824 108.131 47.0564 110.05 44.7238 109.618C40.0586 108.755 37.2909 110.673 32.6258 109.81C27.9606 108.946 25.1929 110.865 20.5278 110.001C18.1952 109.569 18.6303 107.219 21.3979 105.3C24.1656 103.382 28.8308 104.245 33.496 105.109L35.8285 105.541C33.4959 105.109 31.1634 104.677 29.2659 101.895C25.0358 98.6807 18.4731 95.0348 14.2431 91.8208C6.21803 83.0423 0.960655 72.345 0.80354 60.1609C0.646428 47.9768 7.92216 34.7375 14.3277 26.1992C17.5305 21.9301 23.5009 15.7422 29.0363 11.9049C31.8039 9.98618 34.5716 8.06749 37.3393 6.14881C40.107 4.23011 42.8747 2.31143 45.6423 0.392743C47.9749 0.824526 50.3075 1.25631 47.5398 3.175C44.7721 5.09369 42.0045 7.01238 41.5694 9.36284C38.8017 11.2815 36.034 13.2002 33.2663 15.1189C27.731 18.9563 24.5282 23.2254 21.3254 27.4946C13.0224 33.2506 8.51438 44.5712 6.33891 56.3236C6.49602 68.5077 9.42081 78.7731 17.8809 85.2012C22.111 88.4152 26.3411 91.6293 30.5711 94.8433C32.9037 95.2751 35.2363 95.7069 34.8012 98.0573C32.9037 95.2751 29.1088 89.7106 27.2113 86.9283C28.0815 82.2274 33.1817 80.7405 35.0792 83.5227Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download_arrow.f4a6443ca2b227160f52bd9faeabaa1e.svg";
export { ForwardRef as ReactComponent };